export default __webpack_public_path__ + "static/media/logo2.e701de12.png";